const login = document.querySelector(".rc-enter-code");
const sectionPasswordless = document.querySelector(".section-passwordless");
const textForm = document.querySelector(".rc-login-form-button span")
const buttonsForm = document.querySelector(".rc-login-form-button")
const title = document.querySelector(".rc-login--header-title")
const notice = document.querySelector(".section-passwordless__note")

if (login && sectionPasswordless) {
  login.insertAdjacentElement("afterend", sectionPasswordless);
  title.insertAdjacentElement('afterend', notice)

  sectionPasswordless.style.display = "flex";
  notice.style.display = "block"

  // Forzar un reflujo para garantizar que el navegador aplique el cambio de display antes de cambiar la opacidad
  void sectionPasswordless.offsetWidth;
  void buttonsForm.offsetWidth
  
  sectionPasswordless.style.opacity = "1";
  buttonsForm.style.opacity = "1"
}

if (textForm) {
  textForm.textContent = "Sign In"
}